import { render, staticRenderFns } from "./store-cart.vue?vue&type=template&id=a0f2e4a0"
import script from "./store-cart.vue?vue&type=script&lang=js"
export * from "./store-cart.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports